import request from '@/utils/request';

// 登录
export function Login(data) {
    return request({
        url: '/language/login',
        method: 'POST',
        data
    });
}

